export const createIdempotencyKey = (
    scope,
    cryptoImpl = window.crypto,
    now = Date.now
) => {
    if (!/^[A-Za-z0-9._:-]{1,32}$/.test(scope)) {
        throw new TypeError('Invalid idempotency key scope')
    }

    if (typeof cryptoImpl?.randomUUID === 'function') {
        return `${scope}:${cryptoImpl.randomUUID()}`
    }

    if (typeof cryptoImpl?.getRandomValues === 'function') {
        const bytes = cryptoImpl.getRandomValues(new Uint8Array(16))
        const random = Array.from(bytes, (value) =>
            value.toString(16).padStart(2, '0')
        ).join('')
        return `${scope}:${now().toString(36)}:${random}`
    }

    throw new Error('Secure random values are unavailable')
}
